import * as React from 'react';
import { TemplateCreateProvider } from './context/UseTemplateCreateContext';
import TemplateCreate from './TemplateCreate';

export const TemplateCreatePage: React.FC = () => (
  <TemplateCreateProvider>
    <TemplateCreate />
  </TemplateCreateProvider>
);

export default TemplateCreatePage;
